import pageContext from 'salvo-lite/context'
import ChangeClass from './components/ChangeClass'
import Select from './components/Select'
import SwiperSlider from './components/Swiper'
import Preload from './components/Preload'
import Video from './components/Video'
import Slide from './components/Slide'
import Sticky from './components/Sticky'
import Currency from './components/Currency'
import Variants from './components/Variants'
import RecentlyViewed from './components/RecentlyViewed'
import Filter from './components/Filter'
import LoadMore from './components/LoadMore'
import CartCount from './components/CartCount'
import ScrollTo from './components/ScrollTo'
import InViewport from './components/InViewport'
import CustomWishlist from './components/CustomWishlist'
import CollectionAdverts from './components/CollectionAdverts'

import Addresses from './pages/Addresses'
import Login from './pages/Login'
import Product from './pages/Product'
import Collection from './pages/Collection'
import Cart from './pages/Cart'
import Bundle from './pages/Bundle'
import BundleMultiple from './pages/BundleMultiple'

const components = {
    'change-class': ChangeClass,
    'select': Select,
    'swiper': SwiperSlider,
    'preloader': Preload,
    'video': Video,
    'slide': Slide,
    'sticky': Sticky,
    'currency-switch': Currency,
    'variants': Variants,
    'recently-viewed': RecentlyViewed,
    'filter': Filter,
    'load-more': LoadMore,
    'cart-count': CartCount,
    'scroll-to': ScrollTo,
    'in-viewport': InViewport,
    'custom-wishlist': CustomWishlist,
    'collection-adverts': CollectionAdverts
}

const pages = {
    'customers/addresses': Addresses,
    'customers/login': Login,
    'product': Product,
    'collection': Collection,
    'cart': Cart,
    'search': Collection,
    'product.bundle': Bundle,
    'product.bundle-multiple': BundleMultiple
}

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach
}

class Theme {
    constructor () {
        this._components = []
        this._componentsById = {}
    }

    registerComponents (container = document) {
        for (let key in components) {
            var ComponentConstructor = components[key]
            var elements = container.querySelectorAll(`.js-component__${key}, [data-${key}]`)
            for (let elem of elements) {
                var instance = new ComponentConstructor(this, elem)
                this._components.push(instance)
                var id = elem.dataset.componentId
                if (id) {
                    this._componentsById[id] = instance
                }
                instance.onInit()
            }
        }
        window.ThemeComponents = this._components
        window.ThemeComponentsId = this._componentsById
        window.__Theme = this
    }

    registerPages () {
        var context = pageContext.getTemplate()
        for (let page in pages) {
            if (page === context) {
                var instance = new pages[page](this)
                instance.onInit()
            }
        }
    }

    getComponents () {
        return this._components
    }

    getComponentsById (id) {
        return this._componentsById[id]
    }

    getComponentsByType (componentConst, includeSubclasses = true) {
        var r = []
        for (let c of this._components) {
            if (includeSubclasses && c instanceof componentConst) {
                r.push(c)
            } else if (c.constructor === componentConst) {
                r.push(c)
            }
        }
        return r
    }
}

export default Theme



// WEBPACK FOOTER //
// ./src/resources/scripts/Theme.js